
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Airport } from "@/types/airport";

// For filters dropdowns
export const useAirportsForFilters = (filters: { cityId?: string; countryId?: string } = {}) => {
  const { cityId, countryId } = filters;
  
  const queryKey = ['airports-filter', { cityId, countryId }];

  const queryFn = async () => {
    let query = supabase.from('airports').select('id, name_ar, iata_code');
    if (cityId && cityId !== 'all') {
      query = query.eq('city_id', cityId);
    } else if (countryId && countryId !== 'all') {
      query = query.eq('country_id', countryId);
    }
    
    const { data, error } = await query;
    if (error) throw error;
    return data;
  };

  return useQuery({
      queryKey,
      queryFn,
      enabled: (!!cityId && cityId !== 'all') || (!!countryId && countryId !== 'all')
  });
};

// For the main Airports page table/cards
export const useFetchAirports = () => {
    return useQuery({
      queryKey: ['airports'],
      queryFn: async () => {
        const { data, error } = await supabase
          .from('airports')
          .select(`
            *,
            cities(name_ar),
            countries(name_ar)
          `)
          .order('created_at', { ascending: false });
        
        if (error) throw error;
        return data as (Omit<Airport, 'cities' | 'countries'> & { cities: { name_ar: string } | null; countries: { name_ar: string } | null; })[];
      },
    });
};
